"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "M13.9101 16.0788a8.9078 8.9078 0 0 0 2.7396-1.1182c.645-.4009.8402-1.2401.4331-1.8778-.407-.6376-1.259-.8299-1.9065-.429-1.9327 1.1979-4.4199 1.1956-6.3526 0-.6474-.4009-1.4995-.2086-1.9065.429-.407.6353-.2118 1.4769.4332 1.8778a8.9068 8.9068 0 0 0 2.7395 1.1182l-2.6348 2.5974a1.3453 1.3453 0 0 0 0 1.9246c.2713.2649.6236.3986.9759.3986.3546 0 .7069-.1337.9782-.3986l2.592-2.5529 2.592 2.5529c.5403.5322 1.4138.5322 1.9541 0 .5403-.5321.5403-1.3948 0-1.9246l-2.6372-2.5974zM12.0012 5.7195c1.0782 0 1.9541.8627 1.9541 1.9246 0 1.0596-.8759 1.9223-1.9541 1.9223-1.0758 0-1.9541-.8627-1.9541-1.9223 0-1.062.8783-1.9246 1.9541-1.9246zm0 6.5686c2.6015 0 4.7175-2.084 4.7175-4.644 0-2.5646-2.116-4.6486-4.7175-4.6486s-4.7174 2.084-4.7174 4.6463 2.1159 4.6463 4.7174 4.6463z"
  })];
};

exports.default = _default;